module.exports = __webpack_public_path__ + "img/medley.bd65d0c3.jpeg";